import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("[Stimulus] hello#connect — controller ativo neste elemento.", this.element)
    this.element.textContent = "Hello World!"
  }
}
